var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurLead",
      staticStyle: { width: "100%" },
      attrs: { flat: "", id: "conteneurLead" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialogConfirm")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialogConfirm) }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndDown
            ? _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.submitDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-between": "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                !_vm.loadingRes && !_vm.contentDialogRes.length
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.contentDialogConfirm) }
                    })
                  : _c("div", { staticClass: "tf_loading_url" }, [
                      _c("div", { staticClass: "tf_contentLoading" }, [
                        _vm.loadingRes
                          ? _c(
                              "div",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-progress-circular",
                                  {
                                    attrs: {
                                      rotate: -90,
                                      size: 120,
                                      width: 8,
                                      value: _vm.loadingValue,
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t  \t\t\t\t" +
                                        _vm._s(_vm.loadingValue) +
                                        " %\n\t\t\t  \t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contentDialogRes.length
                          ? _c("div", { staticClass: "tf_contentLoadingTxt" }, [
                              _c("div", {
                                staticClass: "contentLoading",
                                domProps: {
                                  innerHTML: _vm._s(_vm.contentDialogRes)
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    ])
              ]),
              _vm._v(" "),
              !_vm.contentDialogRes.length
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("p", [_c("v-spacer")], 1),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("p", [_c("v-spacer")], 1)
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.contentDialogRes.length
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _vm._v("\n              Choissez le prompt :"),
                      _c("br"),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.computedActionUrl,
                          "item-text": "text",
                          "item-value": "id"
                        },
                        on: {
                          change: function($event) {
                            return _vm.actionsPrompt()
                          }
                        },
                        model: {
                          value: _vm.selectActionPrompt,
                          callback: function($$v) {
                            _vm.selectActionPrompt = $$v
                          },
                          expression: "selectActionPrompt"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "justify-space-between": "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c(
                  "div",
                  { staticClass: "table-scroll-area" },
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headersFAQ,
                        items: _vm.prompts,
                        "item-key": "index",
                        loading: _vm.loadingData,
                        "rows-per-page-items": [10, 25, 50]
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "progress",
                          fn: function() {
                            return [
                              _c("v-progress-linear", {
                                attrs: { color: "blue", indeterminate: "" }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialogUpdateFAQ(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.date))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialogUpdateFAQ(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialogUpdateFAQ(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.llm))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialogUpdateFAQ(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.temperature))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left truncate-text",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialogUpdateFAQ(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(props.item.preview))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      { attrs: { left: "" } },
                                      [
                                        _c(
                                          "template",
                                          { slot: "activator" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "infos",
                                                attrs: {
                                                  color: "black lighten-1",
                                                  dark: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialogUpdateFAQ(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("edit")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Voir")])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$vuetify.breakpoint.smAndDown &&
      !_vm.closeDialogUniquement &&
      !_vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              !_vm.loadingModifFAQ
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialogConfirm()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.loadingModifFAQ,
                    disabled: !_vm.selectActionPrompt.length,
                    color: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.submitDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        : !_vm.$vuetify.breakpoint.smAndDown &&
          !_vm.closeDialogUniquement &&
          _vm.modifBaseCo
        ? _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("justCloseDialogConfirm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeDialogConfirm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("ok")))]
              )
            ],
            1
          )
        : _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeDialogConfirm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "90%" },
          model: {
            value: _vm.showDialogComparePrompt,
            callback: function($$v) {
              _vm.showDialogComparePrompt = $$v
            },
            expression: "showDialogComparePrompt"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text compare-title" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title compare-title-text" }, [
                    _vm._v("Comparaison des prompts")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "compare-body" },
                [
                  _c("div", { staticClass: "mb-3" }, [
                    _c("strong", [_vm._v("Section:")]),
                    _vm._v(
                      " " + _vm._s(_vm.selectedPromptField()) + "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pr-3 compare-col",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("h3", { staticClass: "mb-2 compare-label" }, [
                            _vm._v("Prompt actuel")
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.getCurrentPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pl-3 compare-col",
                          attrs: { xs12: "", md6: "" }
                        },
                        [
                          _c("h3", { staticClass: "mb-2 compare-label" }, [
                            _vm._v("Version historisée")
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.getHistoricPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        disabled: !_vm.canDeleteSelectedVersion()
                      },
                      on: { click: _vm.openConfirmDeleteDialog }
                    },
                    [
                      _vm._v(
                        "\n              Supprimer cette version\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled:
                          _vm.selectedPromptField() === "preview" ||
                          !_vm.selectedPromptVersion
                      },
                      on: { click: _vm.openConfirmRestoreDialog }
                    },
                    [
                      _vm._v(
                        "\n              Restaurer cette version\n            "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogConfirmRestore,
            callback: function($$v) {
              _vm.showDialogConfirmRestore = $$v
            },
            expression: "showDialogConfirmRestore"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Confirmation")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v("\n            Le prompt actuel de la section "),
                _c("strong", [_vm._v(_vm._s(_vm.selectedPromptField()))]),
                _vm._v(" sera ecrase par la version historisee.\n            "),
                _c("br"),
                _vm._v("\n            Voulez-vous continuer ?\n          ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogConfirmRestore = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "warning" },
                      on: { click: _vm.confirmRestorePromptSection }
                    },
                    [_vm._v("Confirmer")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "560" },
          model: {
            value: _vm.showDialogConfirmDelete,
            callback: function($$v) {
              _vm.showDialogConfirmDelete = $$v
            },
            expression: "showDialogConfirmDelete"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Confirmation")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n            Cette action va supprimer definitivement la version historisee selectionnee.\n            "
                ),
                _c("br"),
                _vm._v("\n            Voulez-vous continuer ?\n          ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogConfirmDelete = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        loading: _vm.loadingDeleteVersion
                      },
                      on: { click: _vm.confirmDeleteVersion }
                    },
                    [_vm._v("Supprimer")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a67fd020", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a67fd020","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogVersionPrompt.vue
// module id = null
// module chunks = 